'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactCompat = require('preact-compat');

var _preactCompat2 = _interopRequireDefault(_preactCompat);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeoSearchButton = function GeoSearchButton(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      children = _ref.children;
  return _preactCompat2.default.createElement(
    'button',
    { className: className, onClick: onClick, disabled: disabled },
    children
  );
};

GeoSearchButton.defaultProps = {
  disabled: false
};

exports.default = GeoSearchButton;


//////////////////
// WEBPACK FOOTER
// ../node_modules/instantsearch.js/dist-es5-module/src/components/GeoSearchControls/GeoSearchButton.js
// module id = 1123
// module chunks = 20 21 22 23 24 25 26 27 28